import React from 'react';
import { Button } from '../ui/button';

const CustomerDetailsModal = ({ 
  show, 
  customerData, 
  setCustomerData, 
  onCancel, 
  onSubmit, 
  language 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          {language === 'en' ? 'Your Contact Details' : 'I Tuoi Dati'}
        </h3>
        <p className="text-gray-600 mb-6">
          {language === 'en' ? 'We need your details to confirm the booking' : 'Ci servono i tuoi dati per confermare la prenotazione'}
        </p>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              {language === 'en' ? 'Full Name' : 'Nome Completo'} *
            </label>
            <input
              type="text"
              value={customerData.name}
              onChange={(e) => setCustomerData({ ...customerData, name: e.target.value })}
              placeholder={language === 'en' ? 'Mario Rossi' : 'Mario Rossi'}
              data-testid="customer-name-input"
              className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-amber-500 focus:outline-none text-gray-800"
            />
          </div>
          
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              {language === 'en' ? 'Phone Number' : 'Numero di Telefono'} *
            </label>
            <input
              type="tel"
              value={customerData.phone}
              onChange={(e) => setCustomerData({ ...customerData, phone: e.target.value })}
              placeholder="+39 333 1234567"
              data-testid="customer-phone-input"
              className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-amber-500 focus:outline-none text-gray-800"
            />
          </div>
          
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Email {language === 'en' ? '(optional)' : '(opzionale)'}
            </label>
            <input
              type="email"
              value={customerData.email}
              onChange={(e) => setCustomerData({ ...customerData, email: e.target.value })}
              placeholder="mario@email.com"
              data-testid="customer-email-input"
              className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-amber-500 focus:outline-none text-gray-800"
            />
          </div>
        </div>
        
        <div className="flex gap-3 mt-6">
          <Button
            onClick={onCancel}
            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3"
          >
            {language === 'en' ? 'Cancel' : 'Annulla'}
          </Button>
          <Button
            onClick={onSubmit}
            className="flex-1 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-bold py-3"
          >
            {language === 'en' ? 'Confirm & Book' : 'Conferma & Prenota'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetailsModal;
